export const LIBRARY_ROUTE_PATH = "/library";

export const LIBRARY_EMPTY_STATE_TEXT =
  "There are no playlists added in My Playlists yet";
export const LIBRARY_CREATE_BUTTON_TEXT = "Create Playlist";
